import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const LoginService = (payload: LoginType) => {
  return HTTP_CLIENT.post(Endpoint.auth.login, payload);
};

export { LoginService };
